import {LiftType} from 'common/report/util/lift/types';
import {ChartTooltipJsxProps, ChartTooltipProps} from 'common/components/chart-tooltip';

export enum MetricFormatType {
  Percent = `percent`,
  Number = `number`,
}

export type MetricFormatter = MetricFormatType | ((value: number) => string);

export type TooltipDataCallback = (segment: MetricSegment) => ChartTooltipProps;

export type MetricChartClick = (ev: MouseEvent, metricSegment: MetricSegment) => void;

export interface MetricSegment {
  liftComparisonValue?: number;
  comparisonValue?: number;
  label?: string;
  value: number;
  secondaryValue?: number;
  subLabel?: string;
  color?: string;
  path?: string[];
  stepIndex?: number;
}

export interface MultiMetricChartAttributes {
  'lift-type'?: LiftType;
  metrics: MetricSegment[];
  'selected-metric'?: MetricSegment;
}

export interface MultiMetricChartState {
  selfWidth: number;
  selfHeight: number;
  hoverTooltip: ChartTooltipJsxProps | null;
}

export interface GridDimensions {
  columns: number;
  rows: number;
}

export interface GridSetup {
  maxWidth: number;
  maxHeight: number;
  dimensionsForMetrics: GridDimensions[];
}
